import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DOMPurify from "dompurify";
export const toSafeHtml = (input) => {
    if (!input) return "";
    if (typeof input === "string") return DOMPurify.sanitize(input);

    return DOMPurify.sanitize(String(input));
};
export default function TextBlock({ title, subtitle, body, sx = {},src,alt,isAbout = false }) {
  return (
    <Box
      sx={{
        bgcolor: "#ffffffff",
        borderRadius: "30px",
        p: { xs: 2.5, sm: 4, md: 6 },
        boxSizing: "border-box",
        height: { xs: "auto", md: isAbout ? "591.461px" :"auto" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",

          gap: 2,
        overflow: "hidden",
        "& .rs-title": {
          fontFamily: "Zen Maru Gothic",
          fontWeight: 900,
          lineHeight: "120%",
          fontSize: { xs: 20, sm: 28, md: 28 },
          mb: 1,
        },
        "& .rs-subtitle": {
          fontFamily: "Zen Maru Gothic",
          fontWeight: 500,
          fontSize: { xs: 14, md: 16 },
          color: "#111",
          mb: 1,
        },
        "& .rs-body": {
          fontFamily: "Zen Maru Gothic",
          fontWeight: 500,
          lineHeight: "120%",
          fontSize: { xs: 14, md: 16, lg: 17 },
          color: "#111",
          overflowWrap: "break-word",
          wordBreak: "break-word",
        },
        ...sx,
      }}
    >
      {title && (
        <Typography className="rs-title" component="h2">
          {title}
        </Typography>
      )}

      {subtitle && (
        <Typography className="rs-subtitle" component="div">
          {subtitle}
        </Typography>
      )}

        <Box
            className="rs-body"
            sx={{
                width: "100%",
                textAlign: "center",
                "& p": {
                    margin: 0,
                    marginBottom: 1,
                },
            }}
            dangerouslySetInnerHTML={{ __html: toSafeHtml(body) }}
        />
        {src && <Box
            component="img"
            src={src}
            alt={alt}
            sx={{
                width: "60%",
                height: "60%",
                display: "block",
                objectFit: "cover",
                borderRadius:'20px'
            }}
        />}
    </Box>
  );
}
